// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings-module__font-s-10___FAc0l {
  font-size: 10px !important;
}

.Settings-module__font-s-12___aVfgD {
  font-size: 12px !important;
}

.Settings-module__font-s-13___YX2LH {
  font-size: 13px !important;
}

.Settings-module__font-s-14___Wf1NV {
  font-size: 14px !important;
}

.Settings-module__font-s-15___wS9LM {
  font-size: 15px !important;
}

.Settings-module__font-s-16___wwS80 {
  font-size: 16px !important;
}

.Settings-module__font-s-18___FQw4B {
  font-size: 18px !important;
}

.Settings-module__font-s-20___abeS4 {
  font-size: 20px !important;
}

.Settings-module__font-s-22___CYbNf {
  font-size: 22px !important;
}

.Settings-module__font-s-28___Nd4iX {
  font-size: 28px !important;
}

.Settings-module__font-w-400___jMvZB {
  font-weight: 400 !important;
}

.Settings-module__font-w-500____Auux {
  font-weight: 500 !important;
}

.Settings-module__font-w-600___TmJAp {
  font-weight: 600 !important;
}

.Settings-module__font-w-700___h79D9 {
  font-weight: 700 !important;
}

.Settings-module__p-5___lS01R {
  padding: 5px !important;
}

.Settings-module__p-12___Y96E_ {
  padding: 12px !important;
}

.Settings-module__p-16___SieD0 {
  padding: 16px !important;
}

.Settings-module__p-30___J8D5k {
  padding: 30px !important;
}

.Settings-module__p-b-0___w1F2A {
  padding-bottom: 0 !important;
}

.Settings-module__p-b-5___jCL80 {
  padding-bottom: 5px !important;
}

.Settings-module__p-b-10___ky03q {
  padding-bottom: 10px !important;
}

.Settings-module__p-b-12___TE_iC {
  padding-bottom: 12px !important;
}

.Settings-module__p-b-16___AN0td {
  padding-bottom: 16px !important;
}

.Settings-module__p-b-18___RWMCF {
  padding-bottom: 18px !important;
}

.Settings-module__p-b-20___gK0Mz {
  padding-bottom: 20px !important;
}

.Settings-module__p-b-25___Ehixp {
  padding-bottom: 25px !important;
}

.Settings-module__p-b-30___vzEEu {
  padding-bottom: 30px !important;
}

.Settings-module__p-b-50___su049 {
  padding-bottom: 50px !important;
}

.Settings-module__p-t-0___vBmAI {
  padding-top: 0 !important;
}

.Settings-module__p-t-12___WGJEy {
  padding-top: 12px !important;
}

.Settings-module__p-t-16___bhylc {
  padding-top: 16px !important;
}

.Settings-module__p-t-18___sgqCx {
  padding-top: 18px !important;
}

.Settings-module__p-t-20___wqWqO {
  padding-top: 20px !important;
}

.Settings-module__p-t-30___zDzxU {
  padding-top: 30px !important;
}

.Settings-module__p-t-40___pbIOz {
  padding-top: 40px !important;
}

.Settings-module__p-t-50___FohOr {
  padding-top: 50px !important;
}

.Settings-module__p-l-20___CU8Pk {
  padding-left: 20px !important;
}

.Settings-module__p-l-30___QbgCn {
  padding-left: 30px !important;
}

.Settings-module__p-l-40___uz92q {
  padding-left: 40px !important;
}

.Settings-module__p-r-16___H_Vud {
  padding-right: 16px !important;
}

.Settings-module__p-r-20___UdhgM {
  padding-right: 20px !important;
}

.Settings-module__p-r-30___meLlS {
  padding-right: 30px !important;
}

.Settings-module__p-r-50___q9KUp {
  padding-right: 50px !important;
}

.Settings-module__p-r-60___bb01t {
  padding-right: 60px !important;
}

.Settings-module__m-b-1___Gnf3s {
  margin-bottom: 1px !important;
}

.Settings-module__m-b-2___zvWhi {
  margin-bottom: 2px !important;
}

.Settings-module__m-b-6___nxGVK {
  margin-bottom: 6px !important;
}

.Settings-module__m-b-8___dnAqT {
  margin-bottom: 8px !important;
}

.Settings-module__m-b-10___exduy {
  margin-bottom: 10px !important;
}

.Settings-module__m-b-14___d6Sqp {
  margin-bottom: 14px !important;
}

.Settings-module__m-b-16___cuHHC {
  margin-bottom: 16px !important;
}

.Settings-module__m-b-20___oRFoz {
  margin-bottom: 20px !important;
}

.Settings-module__m-b-22___WWF5e {
  margin-bottom: 22px !important;
}

.Settings-module__m-b-24___NuBmc {
  margin-bottom: 24px !important;
}

.Settings-module__m-b-30___sCJrL {
  margin-bottom: 30px !important;
}

.Settings-module__m-b-32___RdhGh {
  margin-bottom: 32px !important;
}

.Settings-module__m-b-40___G4UhM {
  margin-bottom: 40px !important;
}

.Settings-module__m-t-2___lSOBx {
  margin-top: 2px !important;
}

.Settings-module__m-t-3___u1SVB {
  margin-top: 3px !important;
}

.Settings-module__m-t-4___PpIdT {
  margin-top: 4px !important;
}

.Settings-module__m-t-5___Kh0gs {
  margin-top: 5px !important;
}

.Settings-module__m-t-8___m5w7F {
  margin-top: 8px !important;
}

.Settings-module__m-t-10___c6Ym3 {
  margin-top: 10px !important;
}

.Settings-module__m-t-15____t90T {
  margin-top: 15px !important;
}

.Settings-module__m-t-16___GVlvr {
  margin-top: 16px !important;
}

.Settings-module__m-t-20___NEd7k {
  margin-top: 20px !important;
}

.Settings-module__m-t-22___hAZEl {
  margin-top: 22px !important;
}

.Settings-module__m-t-30___FBdpl {
  margin-top: 30px !important;
}

.Settings-module__m-t-32___y34PF {
  margin-top: 32px !important;
}

.Settings-module__m-l-auto____uq9L {
  margin-left: auto !important;
}

.Settings-module__m-l-4___E3Rft {
  margin-left: 4px !important;
}

.Settings-module__m-l-5___L49bi {
  margin-left: 5px !important;
}

.Settings-module__m-l-6___oAi3u {
  margin-left: 6px !important;
}

.Settings-module__m-l-8___DpSw7 {
  margin-left: 8px !important;
}

.Settings-module__m-l-10___kH8ci {
  margin-left: 10px !important;
}

.Settings-module__m-l-16___Zxi6r {
  margin-left: 16px !important;
}

.Settings-module__m-l-20___EcqYN {
  margin-left: 20px !important;
}

.Settings-module__m-l-24___ZsBk8 {
  margin-left: 24px !important;
}

.Settings-module__m-l-30___h_OpQ {
  margin-left: 30px !important;
}

.Settings-module__m-l-35___reFAV {
  margin-left: 35px !important;
}

.Settings-module__m-l-40___etBkQ {
  margin-left: 40px !important;
}

.Settings-module__m-r-8___BL1mX {
  margin-right: 8px !important;
}

.Settings-module__m-r-10___hCd8q {
  margin-right: 10px !important;
}

.Settings-module__m-r-16___BNCBA {
  margin-right: 16px !important;
}

.Settings-module__m-r-20___POmVa {
  margin-right: 20px !important;
}

.Settings-module__m-r-24___xR4Qj {
  margin-right: 24px !important;
}

.Settings-module__m-r-30___HKHic {
  margin-right: 30px !important;
}

.Settings-module__m-r-40___tekc6 {
  margin-right: 40px !important;
}

.Settings-module__border-r-3___VFkAJ {
  border-radius: 3px !important;
}

.Settings-module__border-r-4___BhwZ9 {
  border-radius: 4px !important;
}

.Settings-module__border-r-6___C9rYt {
  border-radius: 6px !important;
}

.Settings-module__border-r-10___I6i3x {
  border-radius: 10px !important;
}

.Settings-module__border-r-12___mi3T4 {
  border-radius: 12px !important;
}

.Settings-module__border-r-16___q2mdN {
  border-radius: 16px !important;
}

.Settings-module__border-r-50___C5eSE {
  border-radius: 50% !important;
}

.Settings-module__primary-border___ZqbtO {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Settings-module__primary-border-b___p9EHT {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Settings-module__primary-border-t___ySvuy {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Settings-module__primary-border-l___tyc7T {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Settings-module__primary-border-r___Pv2l3 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Settings-module__secondary-border___SMS0k {
  border: 1px solid #637768;
}

.Settings-module__secondary-border-b___Ag5_Q {
  border-bottom: 1px solid #637768;
}

.Settings-module__secondary-border-t___PNbra {
  border-top: 1px solid #637768;
}

.Settings-module__secondary-border-l___BGD63 {
  border-left: 1px solid #637768;
}

.Settings-module__secondary-border-r___NmQbk {
  border-right: 1px solid #637768;
}

.Settings-module__gap-0___EWuS6 {
  gap: 0 !important;
}

.Settings-module__gap-2___IuFW8 {
  gap: 2px !important;
}

.Settings-module__gap-4___VMIIU {
  gap: 4px !important;
}

.Settings-module__gap-5___xct1b {
  gap: 5px !important;
}

.Settings-module__gap-6___NKRoK {
  gap: 6px !important;
}

.Settings-module__gap-8___HAVVQ {
  gap: 8px !important;
}

.Settings-module__gap-10___Dl0sn {
  gap: 10px !important;
}

.Settings-module__gap-12___R9C25 {
  gap: 12px !important;
}

.Settings-module__gap-14___jFjxH {
  gap: 14px !important;
}

.Settings-module__gap-16___Rb76q {
  gap: 16px !important;
}

.Settings-module__gap-18___sOUHf {
  gap: 18px !important;
}

.Settings-module__gap-20___PHipg {
  gap: 20px !important;
}

.Settings-module__gap-24___ukm1H {
  gap: 24px !important;
}

.Settings-module__gap-26___Ly9Y6 {
  gap: 26px !important;
}

.Settings-module__gap-30___MgDri {
  gap: 30px !important;
}

.Settings-module__gap-32___icv7H {
  gap: 32px !important;
}

.Settings-module__gap-40___vYS1p {
  gap: 40px !important;
}

.Settings-module__gap-50___B4Af8 {
  gap: 50px !important;
}

.Settings-module__flex-1___a34S_ {
  flex: 1;
}

.Settings-module__flex-none___BXxyA {
  flex: none !important;
}

.Settings-module__flex-column___TzFQj {
  display: flex;
  flex-direction: column !important;
}

.Settings-module__flex-row___Ytuf5 {
  display: flex;
  flex-direction: row !important;
}

.Settings-module__vertically-centered___p18hg {
  display: flex;
  align-items: center !important;
}

.Settings-module__horizontally-centered___nNRTe {
  display: flex;
  justify-content: center !important;
}

.Settings-module__horizontally-end___FxRym {
  display: flex;
  justify-content: end !important;
}

.Settings-module__vertically-start___jj1EO {
  display: flex;
  align-items: start !important;
}

.Settings-module__space-between___B_CcB {
  display: flex;
  justify-content: space-between !important;
}

.Settings-module__flex-wrap___QnvSd {
  flex-wrap: wrap !important;
}

.Settings-module__height-100___fQXJy {
  height: 100%;
}

.Settings-module__width-50___zhRnc {
  width: 50% !important;
}

.Settings-module__width-100___Qm5xc {
  width: 100%;
}

.Settings-module__cursor-pointer___pxz0L {
  cursor: pointer;
}

.Settings-module__cursor-not-allowed___MYaT3 {
  cursor: not-allowed !important;
}

.Settings-module__absolute-centered___ZSM1n {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Settings-module__absolute___pqZHX {
  position: absolute;
}

.Settings-module__relative___ZDba5 {
  position: relative;
}

.Settings-module__fixed___iASEQ {
  position: fixed;
}

.Settings-module__visible___HaMpN {
  opacity: 1;
}

.Settings-module__invisible___plFDp {
  opacity: 0;
}

.Settings-module__col-90___jf1RA {
  width: 90% !important;
}

.Settings-module__col-auto___B67wD {
  width: auto !important;
}

.Settings-module__medical-tabs___SLhmC {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Settings-module__medical-table-new___B1Sha {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Settings-module__medical-table-new___B1Sha:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Settings-module__medical-table-new___B1Sha::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Settings-module__medical-table-new___B1Sha::-webkit-scrollbar-track {
  display: none;
}
.Settings-module__medical-table-new___B1Sha.Settings-module__no-pagination___IDVee {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Settings-module__medical-table-new___B1Sha.Settings-module__no-pagination___IDVee:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Settings-module__medical-table-new___B1Sha.Settings-module__no-pagination___IDVee::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Settings-module__medical-table-new___B1Sha.Settings-module__no-pagination___IDVee::-webkit-scrollbar-track {
  display: none;
}

.Settings-module__medical-table-empty___cd6CR {
  padding: 14px 40px !important;
}

.Settings-module__icon-btn___UZ4Gj {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Settings-module__search-icon___EEezf {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Settings-module__disable-select___Ynhc6 {
  user-select: none;
}

.Settings-module__break-word___gi4Ce {
  word-break: break-word;
}

.Settings-module__popup-clear-btn___DHVIa {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Settings-module__scroll-m-b-20___LXtNl {
  scroll-margin-bottom: 20px;
}

.Settings-module__header___PcPFZ {
  height: 62px;
  margin-left: 2.5em;
}

.Settings-module__settings___pdawg {
  height: calc(100vh - var(--top-navigation) - 62px - var(--patient-details-footer) - 22px);
}
.Settings-module__settings___pdawg .Settings-module__aside____1YE9 {
  width: 270px;
  min-width: 270px;
}
.Settings-module__settings___pdawg .Settings-module__section___Q8HPl {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Settings/Settings.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_sizes.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YEegB;EFdhB,kBAAA;AA8pBF;;AA3pBA;EACE,yFAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,gBAAA;AA8pBJ;AA3pBE;EACE,WAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  height: $settings-header;\n  margin-left: 2.5em;\n}\n\n.settings {\n  height: calc(100vh - var(--top-navigation) - #{$settings-header} - var(--patient-details-footer) - 22px);\n\n  .aside {\n    width: 270px;\n    min-width: 270px;\n  }\n\n  .section {\n    width: 100%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","// font sizes\n$font-sizes: (\n  xx-small: 0.7rem,\n  x-small: 0.8rem,\n  small: 0.9rem,\n  medium: 1rem,\n  large: 1.2rem,\n  x-large: 1.5rem,\n  xx-large: 1.7rem,\n  xxx-large: 1.9rem,\n  header: 2.5rem,\n  largeButton: 1rem,\n);\n\n// component heights\n$top-navigation: 53px;\n$top-header: 62px;\n$nav-header: 70px;\n$settings-header: 62px;\n$documentation-tabs: 49px;\n$patient-details-header: 68px;\n$patient-status-banner: 39px;\n\n// breakpoints\n$breakpoint-desktop-large: 1600px;\n$breakpoint-desktop: 1250px;\n$breakpoint-tablet: 992px;\n$breakpoint-phone: 688px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Settings-module__font-s-10___FAc0l`,
	"fontS12": `Settings-module__font-s-12___aVfgD`,
	"fontS13": `Settings-module__font-s-13___YX2LH`,
	"fontS14": `Settings-module__font-s-14___Wf1NV`,
	"fontS15": `Settings-module__font-s-15___wS9LM`,
	"fontS16": `Settings-module__font-s-16___wwS80`,
	"fontS18": `Settings-module__font-s-18___FQw4B`,
	"fontS20": `Settings-module__font-s-20___abeS4`,
	"fontS22": `Settings-module__font-s-22___CYbNf`,
	"fontS28": `Settings-module__font-s-28___Nd4iX`,
	"fontW400": `Settings-module__font-w-400___jMvZB`,
	"fontW500": `Settings-module__font-w-500____Auux`,
	"fontW600": `Settings-module__font-w-600___TmJAp`,
	"fontW700": `Settings-module__font-w-700___h79D9`,
	"p5": `Settings-module__p-5___lS01R`,
	"p12": `Settings-module__p-12___Y96E_`,
	"p16": `Settings-module__p-16___SieD0`,
	"p30": `Settings-module__p-30___J8D5k`,
	"pB0": `Settings-module__p-b-0___w1F2A`,
	"pB5": `Settings-module__p-b-5___jCL80`,
	"pB10": `Settings-module__p-b-10___ky03q`,
	"pB12": `Settings-module__p-b-12___TE_iC`,
	"pB16": `Settings-module__p-b-16___AN0td`,
	"pB18": `Settings-module__p-b-18___RWMCF`,
	"pB20": `Settings-module__p-b-20___gK0Mz`,
	"pB25": `Settings-module__p-b-25___Ehixp`,
	"pB30": `Settings-module__p-b-30___vzEEu`,
	"pB50": `Settings-module__p-b-50___su049`,
	"pT0": `Settings-module__p-t-0___vBmAI`,
	"pT12": `Settings-module__p-t-12___WGJEy`,
	"pT16": `Settings-module__p-t-16___bhylc`,
	"pT18": `Settings-module__p-t-18___sgqCx`,
	"pT20": `Settings-module__p-t-20___wqWqO`,
	"pT30": `Settings-module__p-t-30___zDzxU`,
	"pT40": `Settings-module__p-t-40___pbIOz`,
	"pT50": `Settings-module__p-t-50___FohOr`,
	"pL20": `Settings-module__p-l-20___CU8Pk`,
	"pL30": `Settings-module__p-l-30___QbgCn`,
	"pL40": `Settings-module__p-l-40___uz92q`,
	"pR16": `Settings-module__p-r-16___H_Vud`,
	"pR20": `Settings-module__p-r-20___UdhgM`,
	"pR30": `Settings-module__p-r-30___meLlS`,
	"pR50": `Settings-module__p-r-50___q9KUp`,
	"pR60": `Settings-module__p-r-60___bb01t`,
	"mB1": `Settings-module__m-b-1___Gnf3s`,
	"mB2": `Settings-module__m-b-2___zvWhi`,
	"mB6": `Settings-module__m-b-6___nxGVK`,
	"mB8": `Settings-module__m-b-8___dnAqT`,
	"mB10": `Settings-module__m-b-10___exduy`,
	"mB14": `Settings-module__m-b-14___d6Sqp`,
	"mB16": `Settings-module__m-b-16___cuHHC`,
	"mB20": `Settings-module__m-b-20___oRFoz`,
	"mB22": `Settings-module__m-b-22___WWF5e`,
	"mB24": `Settings-module__m-b-24___NuBmc`,
	"mB30": `Settings-module__m-b-30___sCJrL`,
	"mB32": `Settings-module__m-b-32___RdhGh`,
	"mB40": `Settings-module__m-b-40___G4UhM`,
	"mT2": `Settings-module__m-t-2___lSOBx`,
	"mT3": `Settings-module__m-t-3___u1SVB`,
	"mT4": `Settings-module__m-t-4___PpIdT`,
	"mT5": `Settings-module__m-t-5___Kh0gs`,
	"mT8": `Settings-module__m-t-8___m5w7F`,
	"mT10": `Settings-module__m-t-10___c6Ym3`,
	"mT15": `Settings-module__m-t-15____t90T`,
	"mT16": `Settings-module__m-t-16___GVlvr`,
	"mT20": `Settings-module__m-t-20___NEd7k`,
	"mT22": `Settings-module__m-t-22___hAZEl`,
	"mT30": `Settings-module__m-t-30___FBdpl`,
	"mT32": `Settings-module__m-t-32___y34PF`,
	"mLAuto": `Settings-module__m-l-auto____uq9L`,
	"mL4": `Settings-module__m-l-4___E3Rft`,
	"mL5": `Settings-module__m-l-5___L49bi`,
	"mL6": `Settings-module__m-l-6___oAi3u`,
	"mL8": `Settings-module__m-l-8___DpSw7`,
	"mL10": `Settings-module__m-l-10___kH8ci`,
	"mL16": `Settings-module__m-l-16___Zxi6r`,
	"mL20": `Settings-module__m-l-20___EcqYN`,
	"mL24": `Settings-module__m-l-24___ZsBk8`,
	"mL30": `Settings-module__m-l-30___h_OpQ`,
	"mL35": `Settings-module__m-l-35___reFAV`,
	"mL40": `Settings-module__m-l-40___etBkQ`,
	"mR8": `Settings-module__m-r-8___BL1mX`,
	"mR10": `Settings-module__m-r-10___hCd8q`,
	"mR16": `Settings-module__m-r-16___BNCBA`,
	"mR20": `Settings-module__m-r-20___POmVa`,
	"mR24": `Settings-module__m-r-24___xR4Qj`,
	"mR30": `Settings-module__m-r-30___HKHic`,
	"mR40": `Settings-module__m-r-40___tekc6`,
	"borderR3": `Settings-module__border-r-3___VFkAJ`,
	"borderR4": `Settings-module__border-r-4___BhwZ9`,
	"borderR6": `Settings-module__border-r-6___C9rYt`,
	"borderR10": `Settings-module__border-r-10___I6i3x`,
	"borderR12": `Settings-module__border-r-12___mi3T4`,
	"borderR16": `Settings-module__border-r-16___q2mdN`,
	"borderR50": `Settings-module__border-r-50___C5eSE`,
	"primaryBorder": `Settings-module__primary-border___ZqbtO`,
	"primaryBorderB": `Settings-module__primary-border-b___p9EHT`,
	"primaryBorderT": `Settings-module__primary-border-t___ySvuy`,
	"primaryBorderL": `Settings-module__primary-border-l___tyc7T`,
	"primaryBorderR": `Settings-module__primary-border-r___Pv2l3`,
	"secondaryBorder": `Settings-module__secondary-border___SMS0k`,
	"secondaryBorderB": `Settings-module__secondary-border-b___Ag5_Q`,
	"secondaryBorderT": `Settings-module__secondary-border-t___PNbra`,
	"secondaryBorderL": `Settings-module__secondary-border-l___BGD63`,
	"secondaryBorderR": `Settings-module__secondary-border-r___NmQbk`,
	"gap0": `Settings-module__gap-0___EWuS6`,
	"gap2": `Settings-module__gap-2___IuFW8`,
	"gap4": `Settings-module__gap-4___VMIIU`,
	"gap5": `Settings-module__gap-5___xct1b`,
	"gap6": `Settings-module__gap-6___NKRoK`,
	"gap8": `Settings-module__gap-8___HAVVQ`,
	"gap10": `Settings-module__gap-10___Dl0sn`,
	"gap12": `Settings-module__gap-12___R9C25`,
	"gap14": `Settings-module__gap-14___jFjxH`,
	"gap16": `Settings-module__gap-16___Rb76q`,
	"gap18": `Settings-module__gap-18___sOUHf`,
	"gap20": `Settings-module__gap-20___PHipg`,
	"gap24": `Settings-module__gap-24___ukm1H`,
	"gap26": `Settings-module__gap-26___Ly9Y6`,
	"gap30": `Settings-module__gap-30___MgDri`,
	"gap32": `Settings-module__gap-32___icv7H`,
	"gap40": `Settings-module__gap-40___vYS1p`,
	"gap50": `Settings-module__gap-50___B4Af8`,
	"flex1": `Settings-module__flex-1___a34S_`,
	"flexNone": `Settings-module__flex-none___BXxyA`,
	"flexColumn": `Settings-module__flex-column___TzFQj`,
	"flexRow": `Settings-module__flex-row___Ytuf5`,
	"verticallyCentered": `Settings-module__vertically-centered___p18hg`,
	"horizontallyCentered": `Settings-module__horizontally-centered___nNRTe`,
	"horizontallyEnd": `Settings-module__horizontally-end___FxRym`,
	"verticallyStart": `Settings-module__vertically-start___jj1EO`,
	"spaceBetween": `Settings-module__space-between___B_CcB`,
	"flexWrap": `Settings-module__flex-wrap___QnvSd`,
	"height100": `Settings-module__height-100___fQXJy`,
	"width50": `Settings-module__width-50___zhRnc`,
	"width100": `Settings-module__width-100___Qm5xc`,
	"cursorPointer": `Settings-module__cursor-pointer___pxz0L`,
	"cursorNotAllowed": `Settings-module__cursor-not-allowed___MYaT3`,
	"absoluteCentered": `Settings-module__absolute-centered___ZSM1n`,
	"absolute": `Settings-module__absolute___pqZHX`,
	"relative": `Settings-module__relative___ZDba5`,
	"fixed": `Settings-module__fixed___iASEQ`,
	"visible": `Settings-module__visible___HaMpN`,
	"invisible": `Settings-module__invisible___plFDp`,
	"col90": `Settings-module__col-90___jf1RA`,
	"colAuto": `Settings-module__col-auto___B67wD`,
	"medicalTabs": `Settings-module__medical-tabs___SLhmC`,
	"medicalTableNew": `Settings-module__medical-table-new___B1Sha`,
	"noPagination": `Settings-module__no-pagination___IDVee`,
	"medicalTableEmpty": `Settings-module__medical-table-empty___cd6CR`,
	"iconBtn": `Settings-module__icon-btn___UZ4Gj`,
	"searchIcon": `Settings-module__search-icon___EEezf`,
	"disableSelect": `Settings-module__disable-select___Ynhc6`,
	"breakWord": `Settings-module__break-word___gi4Ce`,
	"popupClearBtn": `Settings-module__popup-clear-btn___DHVIa`,
	"scrollMB20": `Settings-module__scroll-m-b-20___LXtNl`,
	"header": `Settings-module__header___PcPFZ`,
	"settings": `Settings-module__settings___pdawg`,
	"aside": `Settings-module__aside____1YE9`,
	"section": `Settings-module__section___Q8HPl`
};
module.exports = ___CSS_LOADER_EXPORT___;
